//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/mixins/global'
import axios from 'axios'

export default {
  props: {
    UserAccessData: {}
  },
  data () {
    return {
      Readiness: {
        TotalLate: 0,
        TotalAlert: 0,
        TotalNormal: 0,
        Data: []
      },
      dialog: false
    }
  },
  created () {
    // console.log('Block Fabric')
    console.log(this.UserAccessData.MerIn)
    console.log(this.UserAccessData.MerList)
    console.log(this.UserAccessData.MerListOnly)
  },
  mounted () {
    this.getData()
    this.pullData()
  },
  methods: {
    pullData () {
      this.pulling = setInterval(() => {
        var currentdate = new Date()
        if (currentdate.getMinutes() % 5 === 0 && currentdate.getSeconds() === 0) {
          this.getData()
        }
      }, 1000)
    },
    getData () {
      let params = new FormData()
      params.append('grpin', this.UserAccessData.MerIn)
      axios
        .post(this.$apiFix + '2020ReadinessSum.php/wip_doc_sum_head', params)
        .then(response => {
          console.log(response.data)
          this.Readiness = response.data
        })
        .catch(err => {
          console.error(err)
        })
    }
  }
}
